module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "sm-button sm-edit-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.listGroups
    }
  }, [_c('div', {
    staticClass: "dashicons-before",
    class: _vm.icon
  }), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33ec8f2d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GroupButton.vue
// module id = 17
// module chunks = 0